function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHdiLogo = function SvgHdiLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 2017 1721"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.032 52.396h13.235v39.969H18.032z",
    style: {
      fill: "#1f8a4e"
    },
    transform: "matrix(12.56828 0 0 12.56828 85.015 -216.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.589 52.484h13.323v39.969H44.589z",
    style: {
      fill: "#1f8a4e"
    },
    transform: "matrix(12.56828 0 0 12.56828 85.015 -218.512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.293 38.115h13.323v-39.88H19.94C-13.323-.089-5.206 39.88 23.293 38.115",
    style: {
      fill: "#1f8a4e"
    },
    transform: "matrix(-12.56828 0 0 12.56828 1400.6 463.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21.264V.883c15.441-1.942 16.764 21.44 0 20.381",
    style: {
      fill: "#fff"
    },
    transform: "matrix(12.56828 0 0 12.56828 1101.194 549.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.469 52.396h13.323v39.88h-13.323z",
    style: {
      fill: "#1f8a4e"
    },
    transform: "matrix(12.56828 0 0 12.56828 85.015 -215.182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.267 65.454H44.59v13.323H31.267z",
    style: {
      fill: "#e11c1a"
    },
    transform: "matrix(12.56828 0 0 12.56828 85.015 -209.64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-13.139c-.624-.35-1.823-.849-3.397-.849-2.273 0-3.222 1.324-3.222 2.548 0 1.623 1.074 2.423 3.497 3.471 3.072 1.35 4.546 3.023 4.546 5.646 0 3.197-2.373 5.595-6.669 5.595-1.799 0-3.697-.525-4.621-1.149L-9.217-.3C-8.193.324-6.644.824-5.07.824c2.273 0 3.547-1.174 3.547-2.898 0-1.623-.975-2.622-3.248-3.571-2.847-1.149-4.771-2.873-4.771-5.471 0-3.022 2.423-5.295 6.22-5.295 1.823 0 3.197.449 4.022.874z",
    style: {
      fill: "#1d1d1b",
      fillRule: "nonzero"
    },
    transform: "matrix(12.56828 0 0 12.56828 416.24 1345.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-2.798c.025-1.648-.649-3.697-2.873-3.697-2.123 0-3.022 2.098-3.172 3.697zm2.048 7.744c-.974.449-2.498.824-4.371.824-4.147 0-6.545-2.773-6.545-6.969 0-4.097 2.299-7.369 6.195-7.369 3.872 0 5.421 3.222 5.421 6.619 0 .475-.025.875-.076 1.224H-6.07c.075 3.097 1.998 4.272 4.172 4.272 1.523 0 2.572-.275 3.472-.65z",
    style: {
      fill: "#1d1d1b",
      fillRule: "nonzero"
    },
    transform: "matrix(12.56828 0 0 12.56828 613.742 1314.167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.693c0-1.823-1.199-3.322-2.973-3.322-1.998 0-3.397 1.898-3.397 4.846 0 2.698 1.224 4.621 3.372 4.621C-1.499-2.548 0-3.697 0-5.995zm3.022-5.32c-.075.974-.125 2.123-.125 3.971v7.844c0 2.747-.225 7.818-6.744 7.818-1.599 0-3.272-.35-4.346-1l.649-2.248c.85.5 2.173.975 3.722.975 2.248 0 3.847-1.249 3.847-4.372v-1.323h-.05c-.7 1.174-2.048 2.023-3.822 2.023-3.247 0-5.47-2.872-5.47-6.72 0-4.67 2.822-7.268 5.82-7.268 2.048 0 3.197 1.049 3.771 2.148h.051l.124-1.848z",
    style: {
      fill: "#1d1d1b",
      fillRule: "nonzero"
    },
    transform: "matrix(12.56828 0 0 12.56828 831.655 1386.373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.619c0 1.549.075 2.848.125 3.947h-2.548l-.15-1.999h-.075a4.8 4.8 0 0 1-4.146 2.274c-2.373 0-4.447-1.474-4.447-5.87v-8.193h2.898v7.718c0 2.373.675 3.947 2.572 3.947 1.324 0 2.873-1.05 2.873-3.123v-8.517H0z",
    style: {
      fill: "#1d1d1b",
      fillRule: "nonzero"
    },
    transform: "matrix(12.56828 0 0 12.56828 1096.97 1263.004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.367a4.3 4.3 0 0 0-.85-.075c-1.948 0-3.171 1.598-3.171 3.996v7.294h-2.898v-9.567c0-1.598-.025-2.922-.101-4.196h2.524l.1 2.523h.099c.625-1.748 2.073-2.823 3.572-2.823.276 0 .475.025.725.076z",
    style: {
      fill: "#1d1d1b",
      fillRule: "nonzero"
    },
    transform: "matrix(12.56828 0 0 12.56828 1272.496 1347.43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-9.992c-2.474 0-3.423 2.647-3.423 5.021 0 2.697 1.275 4.97 3.398 4.97 2.098 0 3.397-2.273 3.397-5.02 0-2.273-.949-4.971-3.372-4.971m6.344 4.896c0 5.145-3.347 7.269-6.445 7.269-3.571 0-6.294-2.623-6.294-7.07 0-4.646 2.847-7.268 6.495-7.268 3.771 0 6.244 2.847 6.244 7.069",
    style: {
      fill: "#1d1d1b",
      fillRule: "nonzero"
    },
    transform: "matrix(12.56828 0 0 12.56828 1411.911 1359.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-8.543c-.55-.35-1.498-.774-2.623-.774-1.299 0-1.998.749-1.998 1.673 0 .95.625 1.424 2.298 2.148 2.273.925 3.472 2.174 3.472 4.172 0 2.648-2.023 4.221-5.145 4.221-1.449 0-2.823-.375-3.747-.924l.649-2.148c.699.424 1.974.924 3.148.924 1.549 0 2.298-.749 2.298-1.798 0-1.05-.575-1.624-2.223-2.323-2.448-.975-3.523-2.348-3.523-3.947 0-2.298 1.873-4.121 4.771-4.121 1.35 0 2.523.374 3.272.799z",
    style: {
      fill: "#1d1d1b",
      fillRule: "nonzero"
    },
    transform: "matrix(12.56828 0 0 12.56828 1655.573 1350.27)"
  }));
};
export default SvgHdiLogo;